import { Box, Card, CardContent, Typography, Button, IconButton } from "@mui/material"
import { Print as PrintIcon, Save, Settings as SettingsIcon } from "@mui/icons-material"
import { LabelLayoutSettingsValues } from "./types"
import { forwardRef, useState } from "react"
import LabelLayoutSettings from "./label-layout-settings"
import PrintPreview from "./print-preview"
import { LotBarcodeT } from "."
import TransferList from "./transfer-list"
import { Stack } from "src/shared/components"

interface BarcodeConfigProps {
  onConfigChange: (config: LabelLayoutSettingsValues) => void
  config: LabelLayoutSettingsValues
  onPrint?: () => void
  onSaveConfig?: () => void
  lotBarcodes: LotBarcodeT[]
}

const BarcodeConfigComponent = forwardRef<HTMLDivElement, BarcodeConfigProps>(
  ({ onConfigChange, config, lotBarcodes, onPrint, onSaveConfig }: BarcodeConfigProps, ref) => {
    const [barcodesToPrint, setBarcodesToPrint] = useState<LotBarcodeT[]>([])

    const handlePrint = () => {
      if (onPrint) {
        onPrint()
      }
    }

    const handleSelectedBarcodes = (actionIds: string[]) => {
      // actionIds
      const tempBarcodes: LotBarcodeT[] = actionIds
        ?.map((id) => {
          return lotBarcodes.find((val) => id === val.actionId)
        })
        .filter((val) => !!val)

      setBarcodesToPrint(tempBarcodes)
    }
    return (
      <Box sx={{ position: "relative", pb: { xs: 30, sm: 25 } }}>
        <Card elevation={3} sx={{ mb: 3, borderRadius: 2 }}>
          <CardContent sx={{ p: 3 }}>
            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <SettingsIcon color="primary" sx={{ fontSize: 28 }} />
                <Typography variant="h5" fontWeight="600" color="primary">
                  Barcode Configuration
                </Typography>
              </Box>
              <Stack direction={"row"} spacing={2}>
                <IconButton
                  onClick={onSaveConfig}
                  disabled={!onSaveConfig}
                  color="primary"
                  title="Save as config"
                  sx={{
                    "&:hover": {
                      backgroundColor: (theme) => theme.palette.primary.main,
                      color: (theme) => theme.palette.common.white
                    }
                  }}
                >
                  <Save />
                </IconButton>
                {/* <Button
                  sx={{ borderRadius: 2, padding: "8px" }}
                  color="secondary"
                  variant="contained"
                  startIcon={<Save />}
                  onClick={onSaveConfig}
                  disabled={!onSaveConfig}
                >
                  Save as config
                </Button> */}
                <Button
                  variant="contained"
                  startIcon={<PrintIcon />}
                  // disabled={!isBatchSet}
                  onClick={handlePrint}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    textTransform: "none",
                    fontSize: "16px",
                    fontWeight: 600,
                    boxShadow: 2,
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translateY(-1px)"
                    }
                  }}
                >
                  Print Barcodes
                </Button>
              </Stack>
            </Box>

            {/* Configuration Fields */}
            <TransferList lotBarcodes={lotBarcodes} onActionIdsSelection={handleSelectedBarcodes} />

            {/* Label Layout Settings */}
            <LabelLayoutSettings config={config} onConfigChange={onConfigChange} />
          </CardContent>
        </Card>

        <PrintPreview barcodes={barcodesToPrint} config={config} ref={ref} />
      </Box>
    )
  }
)

export default BarcodeConfigComponent
